import React, {Component} from "react";
import {connect} from "react-redux";
import {ReactSVG} from "react-svg";

import * as componentTypes from "../../constants/componentTypes";

import imgDispensingColoris from "../../resources/img/svgicons/machine-coloris.svg";
import imgDispensing from "../../resources/img/svgicons/dispensing.svg";
import imgHelp from "../../resources/img/svgicons/help.svg";
import imgLoader from "../../resources/img/loader.svg";
import imgLoaderSnowman from "../../resources/img/loader-snowman.svg";
import imgMachine from "../../resources/img/svgicons/machine-grey.svg";
import imgMachineGreen from "../../resources/img/svgicons/machine-green.svg";
import imgMachineGamma from "../../resources/img/svgicons/machine-grey.svg";
import imgMachineGreenGamma from "../../resources/img/svgicons/machine-green.svg";
import imgPrint from "../../resources/img/svgicons/print.svg";
import imgPrintColoris from "../../resources/img/svgicons/print-coloris.svg";

class CustomIcon extends Component {
    getSvgIcon = () => {
        switch (this.props.iconType) {
            case componentTypes.ICON_DISPENSE:
                if (this.props.colorisSoftware) {
                    return imgDispensingColoris;
                }

                return imgDispensing;
            case componentTypes.ICON_LOADER:
                if (this.props.plugins.winter) {
                    return imgLoaderSnowman;
                }

                return imgLoader;
            case componentTypes.ICON_MACHINE:
                if (this.props.colorisSoftware) {
                    return imgDispensingColoris;
                }
                if (this.props.gammaSoftware) {
                    return imgMachineGamma;
                }

                return imgMachine;
            case componentTypes.ICON_MACHINE_DISPENSING:
                if (this.props.colorisSoftware) {
                    return imgDispensingColoris;
                }
                if (this.props.gammaSoftware) {
                    return imgMachineGreenGamma;
                }

                return imgMachineGreen;
            case componentTypes.ICON_PRINT:
                if (this.props.colorisSoftware) {
                    return imgPrintColoris;
                }

                return imgPrint;
            default:
                return imgHelp;
        }
    };

    render() {
        if (this.props.className === null) {
            return <ReactSVG src={this.getSvgIcon()} alt={this.props.alt} />;
        }

        return <ReactSVG src={this.getSvgIcon()} className={this.props.className} alt={this.props.alt} />;
    }
}

export default CustomIcon = connect((store) => {
    return {
        colorisSoftware: store.module.colorisSoftware,
        gammaSoftware: store.module.gammaSoftware,
        plugins: store.module.plugins
    };
})(CustomIcon);
